$(document).ready(function() {

  // Cart Drawer Policy Shake 
  $(document).on('click','.hideContainer',function(){
    $(".cart-policy-text").addClass("shake");
    setTimeout(function() { 
      $(".cart-policy-text").removeClass("shake");
    }, 1500);    
  });

    setTimeout(function() { 
      $(".innerProductItem").addClass("addPosition");
    }, 1000);      
  

  // Random Number Starts
  function randomIntFromInterval(min, max) { // min and max included 
    return Math.floor(Math.random() * (max - min + 1) + min)
  }  
  var rndInt = randomIntFromInterval(5, 15);
  $(".actualPerson").text(rndInt);
  // Random Number Ends


  
  $(document).on('click','.bundleCartVariant .color-swatch',function(){
    let selectedVariantId = $(this).attr("id");
    $(this).parents('.bundleCartVariant').siblings('.priceWithCta').find('#bundleCartCta').attr('data-variant-id', selectedVariantId);
  });

  $(document).on('click','.singleMultipleBundle .product-item .color-swatch',function(){
    let selectedVarId = $(this).attr("id");
    $(this).parents('.product-item').siblings('.innerBundleContent').find('#bundleCartCta').attr('data-variant-id', selectedVarId);

    let selectedImgSrc = $(this).attr("data-variant-img-src");
    let finalSelectedSrc = 'https://cdn.shopify.com/s/files/1/0778/0614/1755/' + selectedImgSrc;
    $(this).parents('.product-item__info').siblings('.product-item__image-wrapper').find('.product-item__primary-image').attr('srcset',finalSelectedSrc); 
    
  });  

  $(document).on('click','.collectionProductItem .color-swatch-list .color-swatch',function(){
    let itemVariantId = $(this).attr("id");
    $(this).parents('.product-item__info-inner').siblings('.product-item__action-list').find('.variantId').attr('value', itemVariantId);
    $(this).parents('.innerProductItem').siblings('.hoverBlock').find('.variantId').attr('value', itemVariantId);
    
    let VariantImgSrc = $(this).attr("data-variant-img-src");
    let finalImgSrc = 'https://cdn.shopify.com/s/files/1/0778/0614/1755/' + VariantImgSrc;
    $(this).parents('.product-item__info').siblings('.product-item__image-wrapper').find('.product-item__primary-image').attr('srcset',finalImgSrc); 
  });

  $(document).on('click','#bundleCartCta',function(){
    var cartVariantId = $(this).attr("data-variant-id");
    $(this).addClass("active");

    jQuery.post('/cart/add.js', {
      items: [
        {
          quantity: 1,
          id: cartVariantId
        }
      ]
    });  
      setTimeout(function() { 
        document.documentElement.dispatchEvent(new CustomEvent('product:added', {
          bubbles: true,
          detail: {
            quantity: 1
          }
        }));
        $('.cartBundleCta a').removeClass("active");
      }, 500);
  });  

  $('.listedHotspots .hotspot:not(:first)').addClass('inactive');
  $('.singleSpotedProduct').hide();
  $('.singleSpotedProduct:first').show();
    
  $('.hotspot').click(function(){
    var t = $(this).attr('id');
    if($(this).hasClass('inactive')){ //this is the start of our condition 
      $('.listedHotspots .hotspot').addClass('inactive');           
      $(this).removeClass('inactive');
      
      $('.singleSpotedProduct').hide();
      $('#'+ t + 'C').fadeIn('slow');
    }
  });  


  $('.listedSpotImages .singleSpotImg:not(:first)').addClass('inactive');
  $('.singleSpotedPart').hide();
  $('.singleSpotedPart:first').show().addClass("currentSpotActive");
  $('.singleSpotedPart:first').find('.flickity-prev-next-button.previous').hide();
  $('.singleSpotedPart:last').find('.flickity-prev-next-button.next').hide();
    
  $('.singleSpotImg').click(function(){
    var d = $(this).attr('id');
    $('.singleSpotedPart').removeClass("currentSpotActive");
    if($(this).hasClass('inactive')){ //this is the start of our condition 
      $('.listedSpotImages .singleSpotImg').addClass('inactive');           
      $(this).removeClass('inactive');
      
      $('.singleSpotedPart').hide();
      $('#'+ d + 'D').fadeIn('slow').addClass("currentSpotActive");

      $('.singleSpotedProduct').hide();
      $('.currentSpotActive .singleSpotedProduct:first').show();
      
    }
  }); 

  $('.imgWithSpot .flickity-prev-next-button.next').click(function(){
    $('.singleSpotedPart.currentSpotActive').next().show().addClass('nowActive');
    $('.singleSpotedPart.currentSpotActive').hide();
    $('.singleSpotedPart').removeClass('currentSpotActive');
    $('.singleSpotedPart.nowActive').find('.singleSpotedProduct:first').show();
    $('.singleSpotedPart.nowActive').addClass('currentSpotActive').removeClass("nowActive");
  });

  $('.imgWithSpot .flickity-prev-next-button.previous').click(function(){
    $('.singleSpotedPart.currentSpotActive').prev().show().addClass('nowActive');
    $('.singleSpotedPart.currentSpotActive').hide();
    $('.singleSpotedPart').removeClass('currentSpotActive');
    $('.singleSpotedPart.nowActive').find('.singleSpotedProduct:first').show();
    $('.singleSpotedPart.nowActive').addClass('currentSpotActive').removeClass("nowActive");
  });  



  $(document).on('click','.toggleGridBtn',function(){
    $(this).toggleClass("active");
    $(".mainCollectionTemplate").toggleClass("applyOneRow");
  });    
  
  

  $(document).on('click','.hoverBlock',function(){
    let productUrl = $(this).attr("data-product-url");
    let finalproductUrl = 'https://www.outdoortoys.de' + productUrl;
    window.location.href = finalproductUrl;
  });      


  var listItems = $(".mainCollectionTemplate .product-item");
  listItems.each(function(idx, li) {    

    // Random Number Starts
    function randomIntNumber(min, max) { // min and max included 
      return Math.floor(Math.random() * (max - min + 1) + min)
    }  
    var rndNumber = randomIntNumber(5, 15);

    // var product = $(li);
    
    $(".actualPerson", $(li)).text(rndNumber);
    // Random Number Ends
          

  });  

  
});

  // Bundle Product Functionality on Product Page 
function addAllItems(id1,id2){
  jQuery.post('/cart/add.js', {
    items: [
      {
        quantity: 1,
        id: id1
      },
      {
        quantity: 1,
        id: id2
      }
    ]
  });
    setTimeout(function() { 
        window.location.href = '/cart'; 
    }, 1000);
        
};

